import type * as React from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  Typography,
  type FormControlProps,
  type TypographyProps,
  styled,
} from "~/common/mui";
import { deepmerge } from "~/common/mui/utils";

export interface FormStaticTextProps extends Partial<FormControlProps> {
  label?: React.ReactNode;
  value: React.ReactNode;
  helperText?: React.ReactNode;
  InputLabelProps?: React.ComponentProps<typeof InputLabel>;
  TypographyProps?: TypographyProps;
  FormHelperTextProps?: React.ComponentProps<typeof FormHelperText>;
}

const TextContainer = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: `${theme.spacing(0.5)} 0`,
}));

export const FormStaticText: React.FC<FormStaticTextProps> = ({
  label,
  value,
  helperText,
  InputLabelProps,
  TypographyProps,
  FormHelperTextProps,
  ...formControlProps
}) => {
  const formHelperTextProps = deepmerge(FormHelperTextProps ?? {}, { sx: { marginTop: "0" } }) ?? {};
  return (
    <FormControl variant="standard" {...formControlProps}>
      {label && (
        <InputLabel shrink {...InputLabelProps}>
          {label}
        </InputLabel>
      )}
      <TextContainer>
        <Typography variant="bodyLarge" {...TypographyProps}>
          {value}
        </Typography>
      </TextContainer>
      {helperText && (
        <FormHelperText variant="standard" {...formHelperTextProps}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};
